import { AbstractControl, ValidationErrors } from '@angular/forms';

export function dateAfterControlValidator(control: AbstractControl, minimumNightsAfter?: number): (innerControl: AbstractControl) => ValidationErrors | null {
	return (innerControl: AbstractControl): ValidationErrors | null => {
		if (control.value && innerControl.value) {
			const input = new Date(innerControl.value);
			const after = new Date(control.value);

			if (input < after) {
				return {
					after: true,
				};
			}

			if (minimumNightsAfter && minimumNightsAfter > 1) {
				const minimumAfter = new Date(after);
				minimumAfter.setDate(minimumAfter.getDate() + minimumNightsAfter - 1);

				if (input < minimumAfter) {
					return {
						minimumAfter: true,
					};
				}
			}
		}

		return null;
	};
}
